var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultDialog',{on:{"close":_vm.close}},[_c('template',{slot:"header"},[_c('Title',[_vm._v("Logboek")])],1),_c('template',{slot:"content"},[_c('div',{staticClass:"overflow-auto"},[_c('StorageDataTable')],1)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }